/** Preset color palette for label creation */
export const LABEL_COLORS = [
	'#ef4444', // red
	'#f97316', // orange
	'#eab308', // yellow
	'#22c55e', // green
	'#3b82f6', // blue
	'#8b5cf6', // purple
	'#ec4899', // pink
	'#6b7280', // gray
] as const
